import Tick from '../tick/tick.core.module';
import Flip from './tick.view.flip.module';
Tick.plugin.add(Flip);
export default Tick;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pqina/flip/dist/flip.module.js
// module id = null
// module chunks = 